/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-01 13:36:04
 */

import * as request from '@/utils/request'

export default {
  getHomeTaxBasisMoney(data){  
    return request.post('/home/get_tax_fee',data)
  },
  getQues(data){  
    return request.post('/paper/answer',data)
  },
  getQuesStatus(){
    return request.get('/paper/exist')
  },
  getQZinfo(data) {
    return request.post('/user/customer_sign',data)
  },
  getPrice(data) {
    return request.post('/home/index', data)
  },
  /**
   * @description 获取账户信息
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getAccountInfo() {
    return request.get('/home/get_account')
  },
  /**
   * @description 获取公告内容
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getAnnouncementList(data) {
    return request.post('/home/get_announcement', data)
  },

  /**
   * @description 解冻
   * @param data
   * @returns {Promise}
   */
  alipay_refund(data) {
    return request.post('/company/alipay_refund', data)
  },

  /**
   * @description 获取联行号列表
   * @param data
   * @returns {*}
   */
  getBankLinkNoList(data) {
    return request.post(`/bank_code/list`, data)
  },

  /**
   * @description 发起退款
   * @param data
   * @returns {*}
   */
  requestRefund(data) {
    return request.post(`/refund/store`, data)
  },

  /**
   * @description 验证码验证是否通过
   * @param data
   * @returns {*}
   */
  verifyCode(data) {
    return request.post(`/sms/verify`, data)
  },
   /**
   * @description 验证手机号是否是登录的手机号
   * @param data
   * @returns {*}
   */
  verifyPhone(data) {
    return request.post(`/sms/verify-with-mobile`, data)
  },
  /**
   * @description 查看退款列表
   * @param data
   * @returns {*}
   */
  checkRefundList(data) {
    return request.get(`/refund/list`, data)
  },

  /**
   * @description 查看流水表
   * @param data
   * @returns {*}
   */
  checkCapitalFlow(data) {
    return request.get(`/record/list`, data)
  },
	postAuthenticateSig(data){
	return request.post(`/passport/authenticateSig`,data)
	}
}
